import { Switch, Route, Redirect } from "react-router-dom";
import useScrollToTop from "../../hooks/useScrollToTop";
import NewPrescription from "./New";
import EditPrescription from "./Edit";
import ListPrescription from "./List";
import Error from "../../components/Error";

const Component = ({ admin, therapist, props }) => {
  const path = "/prescription";

  useScrollToTop();

  return (
    <div className="frame pb-3">
      <Switch>
        <Route
          exact
          path={`${path}`}
          render={() =>
            admin || therapist ? (
              <ListPrescription infoRoute={props} />
            ) : (
              <Error />
            )
          }
        />
        <Route
          path={`${path}/new`}
          render={() =>
            admin || therapist ? (
              <NewPrescription infoRoute={props} />
            ) : (
              <Error />
            )
          }
        />
        <Route
          path={`${path}/:id`}
          render={() =>
            admin || therapist ? (
              <EditPrescription infoRoute={props} />
            ) : (
              <Error />
            )
          }
        />
        <Route
          exact
          path={`${path}/*`}
          render={() => <Redirect to={"/404"} />}
        />
      </Switch>
    </div>
  );
};

export default Component;
